import type { FunctionComponent } from 'react';

import { nuc } from '../../../utils';

import Link from './Link';
import type { LinkProps } from './Link';

const MAILTO_PREFIX = 'mailto:';

export const mailToUrl = (email: string, subject?: string) =>
  `${MAILTO_PREFIX}${email}${subject ? `?subject=${nuc(subject)}` : ''}`;

export type MailToLinkProps = {
  email: string;
  subject?: string;
} & Omit<LinkProps, 'to'>;

/**
 * A "mailto:" Link, for starting an email in the user's email client to a given address.
 */
const MailToLink: FunctionComponent<MailToLinkProps> = ({ email, subject, ...props }) => (
  <Link
    {...props}
    to={mailToUrl(email, subject)}
  />
);

export default MailToLink;
